import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import React from 'react';
import { CurrencyOption, InStoreOption, ShippingDeliveryProps, UKDeliveryDesc } from 'types/next';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';

type ContentDataProps = {
  contentData: ShippingDeliveryProps;
};

const ShippingDelivery = (contentData: ContentDataProps) => {
  const ukDeliveries = contentData?.contentData?.ukDeliveries;
  const additionalDetails = contentData?.contentData?.additionalDetails;
  const inStoreOptions = contentData?.contentData?.inStoreOptions;
  const internationalDeliveries = contentData?.contentData?.europeanAndInternationalDeliveries;
  const selectYourMoney = contentData?.contentData?.selectYourCurrency;
  const additonalInformation = contentData?.contentData?.additionalInformation;
  const unableToDeliver = contentData?.contentData?.unableToDeliver;

  const SubHeading: React.FC<{ subTitle: string }> = ({ subTitle }) => (
    <h2 className="my-13 font-bold leading-[34px] md:mb-[25px] md:text-[34px]">{subTitle}</h2>
  );

  return (
    <div className="shipping-delivery px-10 pb-40 pt-10">
      {/*  */}
      {/* TABLE STYLE SHEET */}
      <style>
        {`
                    table{
                      border: 1px solid black;
                      color:#191d63;
                      text-indent:inital;
                      text-align:left;
                      border-collapse:collapse;
                    }
                    th,td{ padding:5px; }

                   thead tr td{
                   font-weight:bold;
                   }
                      
                      td,th{
                        vertical-align:top;
                      }

                      .unableToDeliver-table tr{
                        border:1px solid black;
                      }

                      .unableToDeliver-table td{
                        line-height:28px;
                      }


                `}
      </style>
      <div className="mt-30">
        <h1 className="font-bold leading-[36px] lg:text-[36px]">{contentData.contentData.serviceName}</h1>
      </div>

      <div className="ukdeliveries ">
        <SubHeading subTitle={ukDeliveries?.heading} />

        {ukDeliveries?.description?.map((desc: UKDeliveryDesc, ind: number) => {
          return (
            <>
              <MarkDownDescription
                key={ind}
                markdownText={desc?.greatSubHeading}
                classname={`mt-10 shipping-delivery${ind}`}
              />
              <br />
            </>
          );
        })}
      </div>

      <hr className=" my-20" />

      <div className="additional-detail">
        {additionalDetails ? (
          <MarkDownDescription markdownText={additionalDetails} classname="shipping-delivery" />
        ) : (
          <></>
        )}
      </div>
      <div className="inStoreOptions">
        <SubHeading subTitle={inStoreOptions?.title} />

        {inStoreOptions?.subTitles.map((desc: InStoreOption, ind: number) => {
          return (
            <div key={ind} className="my-10">
              <MarkDownDescription markdownText={desc?.name} classname="mt-10 shipping-delovery" />
              <MarkDownDescription markdownText={desc?.value} classname="mt-10 shipping-delivery" />
              <br />
            </div>
          );
        })}
      </div>

      <div className="internationalDeliveries my-10">
        <SubHeading subTitle={internationalDeliveries?.title} />

        <MarkDownDescription markdownText={internationalDeliveries?.description} classname="mt-10 shipping-delivery" />
      </div>

      <div className="select-your-currency">
        <MarkDownDescription markdownText={selectYourMoney.title} classname="mb-10 shipping-delivery" />

        <hr className="mb-10" />

        {selectYourMoney?.accordian &&
          selectYourMoney?.accordian?.map((acc: CurrencyOption, ind: number) => {
            return (
              <AccordionBtn
                variant="plusAndMinus"
                className="items-center border-b border-[#d1c9c4] py-15 text-16   leading-8"
                closedSectionTitle={acc?.name}
                sectionTileClassName={'font-semibold text-18'}
                panelClassName="text-primary-black  pt-10"
                key={ind}
                iconClassName="text-black"
              >
                <div dangerouslySetInnerHTML={{ __html: acc.value }} />
              </AccordionBtn>
            );
          })}
      </div>

      <div className="additional-info">
        <SubHeading subTitle={additonalInformation?.title} />

        {additonalInformation?.subTitles?.map((subTitle: InStoreOption, index: number) => {
          return (
            <React.Fragment key={index}>
              <h4 className="mb-10 font-normal md:text-21"> {subTitle?.name}</h4>

              <MarkDownDescription
                markdownText={subTitle?.value}
                classname="shipping-delivery font-normal md:text-16 leading-7"
              />

              <br />
            </React.Fragment>
          );
        })}
      </div>

      <div className="unable-to-deliver text-30">
        <SubHeading subTitle={unableToDeliver?.title} />
      </div>
      {unableToDeliver?.table && (
        <div className="unableToDeliver-table" dangerouslySetInnerHTML={{ __html: unableToDeliver?.table }} />
      )}
    </div>
  );
};

export default ShippingDelivery;
